import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { Subscription } from 'src/features/subscriptions/utils/types';
import { CURRENCY } from 'src/types';

const RESOURCE = '/subscriptions/subscription/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    customer?: string;
    currency?: CURRENCY;
    external_id?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<Subscription>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_SUBSCRIPTIONS_RESOURCE, useQueryHook as useListSubscriptions };
